import { styled } from 'styled-components';

import { cssBreakpoints, spacing } from '#/theme/theme';

const LABELS_HEIGHT_PER_LINE = 20;
const LABELS_LINE_GAP = 8;

export const searchVolopHitLabelsPerLineVar = '--labels-per-line';

export const SearchVolopHitLabels = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${spacing[LABELS_LINE_GAP]};
  margin: 15px 0 10px;

  overflow: hidden;
  ${searchVolopHitLabelsPerLineVar}: 1;

  max-height: calc(
    ${LABELS_HEIGHT_PER_LINE}px * var(${searchVolopHitLabelsPerLineVar}) +
      ${LABELS_LINE_GAP}px * (var(${searchVolopHitLabelsPerLineVar}) - 1)
  );

  @media all and (max-width: ${cssBreakpoints.lgDown}) {
    ${searchVolopHitLabelsPerLineVar}: 2;
  }
`;
